

    <div class="row md-12">
      <div class="col-md-6 mx-auto">

        <button (click)="regresarPagina()" style="width: 100px; height: 30px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
        <div class="card">
      <div class="card-body">
        <form [formGroup]="formularioCambiarPassword" class="form-material m-t-40" (ngSubmit)="actualizarPassword()">


          <div class="form-group">
            <label for="pass1">Nueva contraseña</label>
            <div class="input-group">
              <div class="input-group-addon"></div>
              <input formControlName="pass1" type="password" appVerPassword required minlength="6" maxlength="18" class="form-control"><span class="bar"></span>
            </div>
            <div class="alert-danger" *ngIf="pass1.invalid && (pass1.dirty || pass1.touched)" >
              <div class="container-error-message" *ngIf="pass1.errors.required" >
                La contraseña es requerida
              </div>
              <div class="container-error-message" *ngIf="pass1.errors.minlength">
                La contraseña debe tener mínimo 6 caracteres
              </div>
              <div class="container-error-message" *ngIf="pass1.errors.maxlength">
                La contraseña debe tener máximo 18 caracteres
              </div>
              <div class="container-error-message" *ngIf="(pass1.dirty || pass1.touched) && pass1.invalid && pass1.errors.pattern">
                La contraseña debe contener por lo menos: 1 número, 1 letra mayúscula, 1 letra minúscula
              </div>
            </div>
          </div>


          <div class="form-group">
            <label for="pass2">Confirmar nueva contraseña</label>
            <div class="input-group">
              <div class="input-group-addon"></div>
              <input formControlName="pass2" type="password" appVerPassword required minlength="6" maxlength="18" class="form-control"><span class="bar"></span>
            </div>
            <div class="alert-danger" *ngIf="pass2.invalid && (pass2.dirty || pass2.touched)" >
              <div class="container-error-message" *ngIf="pass2.errors.required" >
                La confirmación de la contraseña es requerida
              </div>
              <div class="container-error-message" *ngIf="pass2.errors.minlength">
                La contraseña debe tener mínimo 6 caracteres
              </div>
              <div class="container-error-message" *ngIf="(pass2.dirty || pass2.touched) && pass2.invalid && pass2.errors.pattern">
                La contraseña debe contener por lo menos: 1 número, 1 letra mayúscula, 1 letra minúscula
              </div>
              <div class="container-error-message" *ngIf="pass2.errors.maxlength">
                La contraseña debe tener máximo 18 caracteres
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="formularioCambiarPassword.errors?.comparandoPassword && !formularioCambiarPassword.pristine" >
            <p class="text-danger">
              Las contraseñas deben ser iguales
            </p>
          </div>


          <button type="submit" class="btn btn-block btn-lg btn-info btn-rounded" [disabled]="!formularioCambiarPassword.valid">
            Cambiar Contraseña</button>
        </form>
      </div>
    </div>
  </div>
</div>
